const Video = {
  path: "",
  name: "",
  redirect: "/video",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/video",
      redirect: "/video",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Video",
      meta: {
        requiresAuth: true,
        activeUrl: "/video",
        parent: "video",
        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/video/Index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/video",
            parent: "video",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Video Detail",
          component: () => import("@/views/pages/video/Details"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/video",
            parent: "video",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};

export default Video;
